if (!customElements.get('footer-newsletter-form')) {
  class FooterNewsletterForm extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.form = this.querySelector('[data-footer-newsletter]');
      this.emailInput = this.form?.querySelector('[name="ue"]');
      this.submitButton = this.form?.querySelector('[type="submit"]');
      this.message = this.form?.querySelector('[data-footer-newsletter-message]');

      if (!this.form || !this.emailInput || !this.submitButton || !this.message) return;

      this.dataset.initialized = 'true';
      this.defaultButtonLabel = this.submitButton.textContent;
      this.handleSubmit = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this.handleSubmit);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.handleSubmit);
      delete this.dataset.initialized;
    }

    async handleSubmit(event) {
      event.preventDefault();

      if (this.form.getAttribute('aria-busy') === 'true') return;

      this.setLoading(true);
      this.hideMessage();
      this.emailInput.removeAttribute('aria-invalid');

      try {
        const response = await fetch(this.form.dataset.ajaxAction, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
          body: this.getFormBody()
        });
        const result = await response.json();

        if (!response.ok || result.ok !== true) {
          this.emailInput.setAttribute('aria-invalid', 'true');
          this.showMessage(this.getErrorMessage(result), 'error');
          return;
        }

        this.form.reset();
        this.showMessage('Thanks for signing up.', 'success');
      } catch {
        this.emailInput.setAttribute('aria-invalid', 'true');
        this.showMessage('Something went wrong. Please try again.', 'error');
      } finally {
        this.setLoading(false);
      }
    }

    getFormBody() {
      const body = new URLSearchParams();

      for (const [name, value] of new FormData(this.form).entries()) {
        body.append(name, value);
      }

      return body.toString();
    }

    getErrorMessage(result) {
      if (!Array.isArray(result?.errors)) return 'Something went wrong. Please try again.';

      const errors = result.errors
        .map(error => (Array.isArray(error) ? error[1] : error))
        .filter(Boolean)
        .join(' ');

      return errors || 'Something went wrong. Please try again.';
    }

    setLoading(isLoading) {
      this.form.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      this.submitButton.disabled = isLoading;
      this.submitButton.textContent = isLoading ? 'Signing up…' : this.defaultButtonLabel;
    }

    hideMessage() {
      this.message.hidden = true;
      this.message.textContent = '';
      delete this.message.dataset.state;
    }

    showMessage(message, state) {
      this.message.textContent = message;
      this.message.dataset.state = state;
      this.message.hidden = false;
      this.message.focus();
    }
  }

  customElements.define('footer-newsletter-form', FooterNewsletterForm);
}
